module.exports = __webpack_public_path__ + "images/_/programs/h2whoaHybrid/images/characters/ian_arms_folded-45361bb36249f0897318690f5b4521d2.png";


//////////////////
// WEBPACK FOOTER
// ./programs/h2whoaHybrid/images/characters/ian_arms_folded.png
// module id = 892
// module chunks = 2